<template>
  <div class="notFoundContainer">
    <a-result status="404" title="404" sub-title="Sorry, the page you visited does not exist.">
      <template #extra>
        <a-button type="primary" @click="backHome">Back Home</a-button>
      </template>
    </a-result>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
// 导入的其他文件 例如：import moduleName from 'modulePath';

export default {
  //import所引入的组件注册
  components: {},
  setup() {
    const router = useRouter();
    const backHome = () => {
      router.push("/index");
    };
    return {
      backHome
    };
  }
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.notFoundContainer {
  margin-top: 80px;
}
</style>